import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDkitrQaQRrN6sh-dCR9oGV51Ea5-fZbrw",
  authDomain: "gestor-dinero.firebaseapp.com",
  projectId: "gestor-dinero",
  storageBucket: "gestor-dinero.firebasestorage.app",
  messagingSenderId: "327325542642",
  appId: "1:327325542642:web:5aa00e5234efe5d461486b",
  measurementId: "G-Y1KJMQTRBK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth };